<template>
  <a-drawer
    :title="title"
    :width="1024"
    placement="right"
    :closable="true"
    @close="close"
    :visible="visible"
  >
    <a-tabs v-model="tabsKey" v-if="visible">
      <!-- Tab1: 基本信息 -->
      <a-tab-pane key="1" tab="基本信息">
        <a-spin :spinning="confirmLoading">
          <a-form :form="form" v-if="visible">
            <a-row :gutter="24">
              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="站点">
                  {{ model.siteName }}
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="运维人员">
                  <a-tree-select
                    style="width: 100%"
                    :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                    :treeData="userTree"
                    :disabled="disableSubmit"
                    show-search
                    treeNodeFilterProp="title"
                    v-decorator="['userId', validatorRules.userId]"
                    placeholder="请选择运维人员"
                  >
                  </a-tree-select>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="维护类型">
                  <a-select
                    v-decorator="['maintenanceType', validatorRules.maintenanceType]"
                    placeholder="请选择维护类型"
                    :disabled="disableSubmit"
                    @change="onMaintenanceTypeChange"
                  >
                    <a-select-option v-for="item in maintenanceTypeOptions" :key="item.value" :value="item.value">
                      {{ item.text }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <!-- 月/季度质控时显示质控措施选择 -->
              <a-col :md="12" :sm="24" v-if="showQcMeasureInTab1">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="质控措施">
                  <a-select
                    v-model="selectedQcMeasure"
                    placeholder="请选择质控措施"
                    :disabled="disableSubmit"
                  >
                    <a-select-option v-for="item in filteredQcMeasureOptions" :key="item.value" :value="item.value">
                      {{ item.text }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="填报时间">
                  <a-date-picker
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm"
                    v-decorator="['maintenanceDate', validatorRules.maintenanceDate]"
                    :show-time="{ format: 'HH:mm' }"
                    :disabled="disableSubmit"
                  />
                </a-form-item>
              </a-col>
              <a-col :md="24" :sm="24">
                <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" label="备注">
                  <a-textarea placeholder="请输入备注" v-decorator="['remark', {}]" :disabled="disableSubmit" />
                </a-form-item>
              </a-col>
            </a-row>
            <!-- 主表附件 -->
            <a-row style="margin-top: 10px">
              <a-col>
                <iws-upload
                  ref="iwupload"
                  :options="{ btnText: '上传' }"
                  :disableSubmit="disableSubmit"
                  filesrc="om_qc_ledger"
                  :srcid="this.model.id"
                >
                </iws-upload>
              </a-col>
            </a-row>
            <div class="drawer-msg" v-show="disableSubmit">
              <a-row>
                <a-col :span="12"> 创建信息：{{ model.createBy_userName }} （{{ model.createTime }}） </a-col>
                <a-col :span="12" v-if="model.updateBy_userName">
                  最后修改信息：{{ model.updateBy_userName }} （{{ model.updateTime }}）
                </a-col>
              </a-row>
            </div>
          </a-form>
          <div class="drawer-tool" v-show="!disableSubmit">
            <a-button type="primary" icon="check" @click="tabsKey = '2'">开始填报</a-button>
          </div>
        </a-spin>
      </a-tab-pane>

      <!-- Tab2: 质控内容 -->
      <a-tab-pane key="2" tab="质控内容">
        <a-spin :spinning="confirmLoading">
          <component
            :is="currentFormComponent"
            ref="qcForm"
            :disableSubmit="disableSubmit"
            :siteId="model.siteId"
            :st="currentSt"
            :maintenanceType="currentMaintenanceType"
            :qcMeasure="selectedQcMeasure"
            :pagePath="pagePath"
            :dataItems="currentItems"
          />
          <div class="drawer-tool">
            <a-button @click="close" style="margin-right: 10px">关闭</a-button>
            <a-button v-show="!disableSubmit" type="primary" @click="handleSubmit" :loading="confirmLoading">确定提交</a-button>
          </div>
        </a-spin>
      </a-tab-pane>
    </a-tabs>
  </a-drawer>
</template>

<script>
import { ModalFormMixin } from '@/mixins/ModalFormMixin'
import { httpAction, getAction } from '@/api/manage'
import { queryUserTreeList, ajaxGetDictItems } from '@/api/api'
import moment from 'moment'
import IwsUpload from '@comp/upload/IwsUpload.vue'
import St21WeekForm from './St21WeekForm'
import St21MonthMultipointForm from './St21MonthMultipointForm'
import St21MonthInterventionForm from './St21MonthInterventionForm'
import St21MonthSpikedForm from './St21MonthSpikedForm'
import St31WeekForm from './St31WeekForm'
import St31QuarterForm from './St31QuarterForm'
import St31DailyForm from './St31DailyForm'
import St32WeekForm from './St32WeekForm'
import St32DailyForm from './St32DailyForm'

export default {
  name: 'QcLedgerDrawer',
  mixins: [ModalFormMixin],
  components: {
    IwsUpload,
    St21WeekForm, St21MonthMultipointForm, St21MonthInterventionForm, St21MonthSpikedForm,
    St31WeekForm, St31QuarterForm, St31DailyForm,
    St32WeekForm, St32DailyForm,
  },
  props: {
    pagePath: {
      type: String,
      default: '/om/qc/ledger',
    },
  },
  data() {
    return {
      title: '质量控制台账',
      visible: false,
      tabsKey: '1',
      confirmLoading: false,
      disableSubmit: false,
      currentSt: '',
      currentMaintenanceType: '',
      selectedQcMeasure: undefined,
      userTree: [],
      maintenanceTypeOptions: [],
      qcMeasureOptions: [],
      currentItems: [],
      model: {},
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
      validatorRules: {
        userId: { rules: [{ required: true, message: '请选择运维人员' }] },
        maintenanceType: { rules: [{ required: true, message: '请选择维护类型' }] },
        maintenanceDate: { rules: [{ required: true, message: '请选择维护时间' }] },
      },
    }
  },
  computed: {
    /** 月/季度质控时在Tab1显示质控措施选择 */
    showQcMeasureInTab1() {
      return this.currentMaintenanceType === 'month' || this.currentMaintenanceType === 'quarter'
    },
    /** 根据维护类型过滤质控措施选项 */
    filteredQcMeasureOptions() {
      if (!this.currentMaintenanceType) return []
      return this.qcMeasureOptions.filter((item) => {
        let types = (item.depict || '').split(',')
        return types.includes(this.currentMaintenanceType)
      })
    },
    /** 当前使用的子表组件 */
    currentFormComponent() {
      if (!this.currentSt || !this.currentMaintenanceType) return null
      // 周/日常：多条模式
      if (this.currentMaintenanceType === 'week' || this.currentMaintenanceType === 'daily') {
        switch (this.currentSt) {
          case '21': return 'St21WeekForm'
          case '31': return this.currentMaintenanceType === 'week' ? 'St31WeekForm' : 'St31DailyForm'
          case '32': return this.currentMaintenanceType === 'week' ? 'St32WeekForm' : 'St32DailyForm'
        }
      }
      // 月/季度：单条模式
      if (this.currentMaintenanceType === 'month' || this.currentMaintenanceType === 'quarter') {
        let key = this.currentSt + '_' + this.selectedQcMeasure
        switch (key) {
          case '21_multipoint_linear': return 'St21MonthMultipointForm'
          case '21_integrated_intervention': return 'St21MonthInterventionForm'
          case '21_spiked_recovery': return 'St21MonthSpikedForm'
          case '31_indication_error': return 'St31QuarterForm'
        }
      }
      return null
    },
  },
  methods: {
    /** 新增 */
    add(siteId) {
      this.visible = true
      this.tabsKey = '1'
      this.model = { siteId: siteId }
      this.currentItems = []
      this.selectedQcMeasure = undefined
      this.currentMaintenanceType = ''
      this.$nextTick(() => {
        this.form.resetFields()
        this.loadUserTree()
        this.loadDicts()
        // 设置站点名称（从列表带入）
        this.loadSiteInfo(siteId)
        // 默认填充运维人员和维护时间
        this.form.setFieldsValue({
          userId: String(this.$store.getters.userInfo.id),
          maintenanceDate: moment()
        })
      })
    },
    /** 编辑 */
    edit(record) {
      this.visible = true
      this.tabsKey = '1'
      this.selectedQcMeasure = undefined
      this.currentMaintenanceType = ''
      this.currentItems = []
      this.loadDetail(record.id)
    },
    /** 查看 */
    detail(record) {
      this.visible = true
      this.tabsKey = '1'
      this.selectedQcMeasure = undefined
      this.currentMaintenanceType = ''
      this.currentItems = []
      this.loadDetail(record.id)
    },
    /** 加载详情 */
    loadDetail(id) {
      this.confirmLoading = true
      getAction(this.pagePath + '/' + id).then((res) => {
        if (res.success) {
          this.model = res.result
          this.currentSt = res.result.st || this.currentSt
          this.currentMaintenanceType = res.result.maintenanceType
          // 按st设置子表数据
          switch (this.currentSt) {
            case '21': this.currentItems = res.result.st21Items || []; break
            case '31': this.currentItems = res.result.st31Items || []; break
            case '32': this.currentItems = res.result.st32Items || []; break
          }
          // 月/季度回填质控措施
          if (this.showQcMeasureInTab1 && this.currentItems.length > 0) {
            this.selectedQcMeasure = this.currentItems[0].qcMeasure
          }
          this.$nextTick(() => {
            this.form.setFieldsValue({
              userId: res.result.userId,
              maintenanceType: res.result.maintenanceType,
              maintenanceDate: res.result.maintenanceDate ? moment(res.result.maintenanceDate) : null,
              remark: res.result.remark,
            })
            this.loadUserTree()
            this.loadDicts()
          })
        }
        this.confirmLoading = false
      })
    },
    /** 加载站点信息 */
    loadSiteInfo(siteId) {
      if (!siteId) return
      // 从 sessionStorage 获取当前选中的站点名称（由 siteSelect 组件写入）
      let siteName = sessionStorage.getItem('siteName')
      if (siteName) {
        this.$set(this.model, 'siteName', siteName)
      }
    },
    /** 加载人员树 */
    loadUserTree() {
      if (this.userTree.length > 0) return
      queryUserTreeList().then((res) => {
        if (res.success) {
          this.userTree = res.result || []
        }
      })
    },
    /** 加载字典 */
    loadDicts() {
      if (!this.currentSt) return
      // 维护类型字典
      ajaxGetDictItems('qc_maintenance_type_st' + this.currentSt).then((res) => {
        if (res.success) this.maintenanceTypeOptions = res.result || []
      })
      // 质控措施字典
      ajaxGetDictItems('qc_measure_st' + this.currentSt).then((res) => {
        if (res.success) this.qcMeasureOptions = res.result || []
      })
    },
    /** 维护类型变更 */
    onMaintenanceTypeChange(value) {
      this.currentMaintenanceType = value
      this.selectedQcMeasure = undefined
      this.currentItems = []
    },
    /** 提交 */
    handleSubmit() {
      // 从子组件收集子表数据
      let qcFormRef = this.$refs.qcForm
      if (!qcFormRef) {
        this.$message.warning('请先填报质控内容')
        return
      }
      let itemsData = qcFormRef.collectData()
      if (!itemsData) return // 子组件校验失败

      this.form.validateFields((err, values) => {
        if (err) {
          this.tabsKey = '1'
          return
        }
        this.confirmLoading = true
        let formData = {
          ...this.model,
          ...values,
        }
        // 按st设置对应子表数据
        switch (this.currentSt) {
          case '21': formData.st21Items = itemsData; break
          case '31': formData.st31Items = itemsData; break
          case '32': formData.st32Items = itemsData; break
        }
        // 收集附件
        if (this.$refs.iwupload) {
          let files = this.$refs.iwupload.getUploadList ? this.$refs.iwupload.getUploadList() : {}
          formData.sysFileList = files.sysFileList || []
          formData.fileDelList = files.fileDelList || []
        }
        // 格式化所有日期对象为标准字符串
        let formatDates = (obj) => {
          for (let key in obj) {
            let val = obj[key]
            if (val && typeof val === 'object') {
              if (moment.isMoment(val)) {
                obj[key] = val.format('YYYY-MM-DD HH:mm:ss')
              } else if (val instanceof Date) {
                obj[key] = moment(val).format('YYYY-MM-DD HH:mm:ss')
              } else if (Array.isArray(val) || Object.prototype.toString.call(val) === '[object Object]') {
                formatDates(val)
              }
            } else if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(val)) {
              obj[key] = moment(val).format('YYYY-MM-DD HH:mm:ss')
            }
          }
        }
        formatDates(formData)
        
        let method = formData.id ? 'put' : 'post'
        httpAction(this.pagePath, formData, method).then((res) => {
          if (res.success) {
            this.$message.success(res.message)
            this.$emit('ok')
            this.close()
          } else {
            this.$message.warning(res.message)
          }
          this.confirmLoading = false
        })
      })
    },
    close() {
      this.visible = false
      this.tabsKey = '1'
      this.model = {}
      this.currentItems = []
      this.currentMaintenanceType = ''
      this.selectedQcMeasure = undefined
    },
  },
}
</script>
<style scoped>
.drawer-tool {
  text-align: center;
  padding: 15px 0;
}
.drawer-msg {
  padding: 10px 0;
  color: #999;
  font-size: 12px;
}
</style>
